<template>
  <div class="text-center form-wrapper">
    <form
      v-if="loginRequired"
      class="form-signin"
      v-on:submit.prevent="submitLogin"
    >
      <img
        class="mb-4"
        src="/img/bootstrap-solid.svg"
        alt=""
        width="72"
        height="72"
      />
      <h1 class="h3 mb-3 font-weight-normal">{{ $t("login.title") }}</h1>

      <label for="inputEmail" class="sr-only">{{
        $t("login.enterEmail")
      }}</label>
      <input
        type="email"
        id="inputEmail"
        class="form-control"
        required
        autofocus
        v-model="email"
      />

      <label for="inputPassword" class="sr-only">{{
        $t("login.enterPassword")
      }}</label>
      <input
        type="password"
        id="inputPassword"
        class="form-control"
        required
        v-model="password"
      />

      <button class="btn btn-lg btn-primary btn-block" type="submit">
        {{ $t("login.login") }}
      </button>

      <button class="btn btn-lg btn-primary btn-block" type="submit">
        {{ $t("login.login_as_guest") }}
      </button>
    </form>
  </div>
</template>

<script>
import store from "@/store/store";

export default {
  data() {
    return {
      email: "",
      password: "",
      loginError: false,
      error: null
    };
  },
  computed: {
    loginRequired() {
      return store.getters["view/view"].auth !== "guestOnly";
    }
  },
  mounted() {
    if (!this.loginRequired) {
      this.email = "guest@geofoto.si";
      this.password = "guest";

      this.submitLogin();
    }
  },
  methods: {
    submitLogin() {
      this.loginError = false;

      store
        .dispatch("user/login", {
          email: this.email,
          password: this.password
        })
        .then(() => {
          if (this.$route.query.redirect) {
            return this.$router.push(this.$route.query.redirect);
          }
          this.$router.push({ name: "map" });
        })
        .catch(error => {
          this.error = error;
          this.loginError = true;
        });
    }
  }
};
</script>

<style scoped>
.form-wrapper {
  min-height: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
}
.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: 0 auto;
}
.form-signin .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 16px;
}
.form-signin .form-control:focus {
  z-index: 2;
}
.form-signin input[type="email"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.form-signin input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>
